module.exports = __webpack_public_path__ + "img/hd.08dcafe9.jpg";